import React from "react";

const usd = (n) => `$${(n || 0).toFixed(4)}`;
const LABELS = {
  phase8_brief_summary: "Construction IQ summary", portfolio_media_draft: "Portfolio photo drafts",
  website_media_draft: "Website photo drafts", integration_check: "AI provider check", integration_health_ping: "AI health ping",
  dev_service_images: "Service images (developer)",
};

// Per-feature usage. Cards below 640px, a table above (no sideways scrolling on phones).
export default function AiUsageTable({ rows }) {
  if (!rows.length) return <p className="text-sm" data-testid="ai-usage-empty">No AI calls this month.</p>;
  return (
    <section aria-labelledby="ai-usage-title" className="space-y-2" data-testid="ai-usage-features">
      <h2 id="ai-usage-title" className="font-display font-semibold">By feature</h2>
      <ul className="sm:hidden space-y-2">
        {rows.map((r) => (
          <li key={r.feature} className="border border-erf-borderCream rounded bg-white p-3 text-sm" data-testid={`ai-usage-card-${r.feature}`}>
            <p className="font-semibold">{LABELS[r.feature] || r.feature}</p>
            <p>{r.calls} call(s){r.failed ? `, ${r.failed} failed` : ""} · estimated {usd(r.est_usd)} · recorded {usd(r.actual_usd)}</p>
          </li>
        ))}
      </ul>
      <table className="hidden sm:table w-full text-sm bg-white border border-erf-borderCream" data-testid="ai-usage-table">
        <thead><tr className="text-left bg-erf-cream">
          <th className="px-3 py-2">Feature</th><th className="px-3 py-2 text-right">Calls</th><th className="px-3 py-2 text-right">Failed</th>
          <th className="px-3 py-2 text-right">Estimated</th><th className="px-3 py-2 text-right">Recorded</th><th className="px-3 py-2 text-right">Provider-reported</th>
        </tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.feature} className="border-t border-erf-borderCream" data-testid={`ai-usage-row-${r.feature}`}>
              <td className="px-3 py-2">{LABELS[r.feature] || r.feature}</td><td className="px-3 py-2 text-right">{r.calls}</td>
              <td className="px-3 py-2 text-right">{r.failed}</td><td className="px-3 py-2 text-right">{usd(r.est_usd)}</td>
              <td className="px-3 py-2 text-right">{usd(r.actual_usd)}</td><td className="px-3 py-2 text-right">{r.provider_reported_calls}/{r.calls}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
